import { ReviewCheckStatus } from './regulation-review-checker-registry'
import {
    LEGISLATION_KEYS,
    LEGISLATION_STATUSES,
} from './regulation-review-options'
import StructuredClaimsEditor from './claims/StructuredClaimsEditor.vue'

const clone = value => JSON.parse(JSON.stringify(value || {}))

export default {
    props: {
        number: {
            type: Number,
            required: true,
        },
        regulation: {
            type: Object,
            required: true,
        },
        exemptions: {
            type: Array,
            default: () => [],
        },
        evaluation: {
            type: Object,
            required: true,
        },
        relatedSubstances: {
            type: Array,
            default: () => [],
        },
        expanded: {
            type: Boolean,
            default: true,
        },
        unavailableLegislationKeys: {
            type: Array,
            default: () => [],
        },
        claimEditorMode: {
            type: String,
            default: 'structured',
        },
        claimsEditorComponent: {
            type: [Object, Function],
            default: () => StructuredClaimsEditor,
        },
    },
    data() {
        return {
            ReviewCheckStatus,
        }
    },
    computed: {
        claims() {
            return Array.isArray(this.regulation.claims) ? this.regulation.claims : []
        },
        usesStructuredClaimsEditor() {
            return this.claimEditorMode === 'structured'
        },
        legislationKeyOptions() {
            return LEGISLATION_KEYS.map(value => ({
                id: value,
                label: this.translate(
                    `Component(ResearchReviewProcessEnum):legislation-key-${value}`,
                    this.humanize(value),
                ),
                disabled: this.unavailableLegislationKeys.includes(value)
                    && value !== this.regulation.key,
            }))
        },
        statusOptions() {
            return LEGISLATION_STATUSES.map(value => ({
                id: value,
                label: this.statusLabel(value),
            }))
        },
        summaryText() {
            return this.translate(
                'Component(ResearchReviewProcess):regulation-summary',
                '{claims} claims · {exemptions} exemptions',
            )
                .replace('{claims}', String(this.claims.length))
                .replace('{exemptions}', String(this.exemptions.length))
        },
    },
    methods: {
        translate(key, fallback) {
            const translation = this.$t(key)

            return translation && translation !== key ? translation : fallback
        },
        humanize(value) {
            return String(value || '').replace(/_/g, ' ').replace(/\b\w/g, letter => letter.toUpperCase())
        },
        selectedOption(options, value) {
            return options.find(option => option.id === value) || null
        },
        isLegislationOptionSelectable(option) {
            return !option.disabled
        },
        statusLabel(value) {
            return this.translate(
                `Component(ResearchReviewProcess):legislation-status-${value}`,
                this.humanize(value),
            )
        },
        updateRegulation(key, value) {
            this.$emit('input', {
                ...clone(this.regulation),
                [key]: value,
            })
        },
        updateClaims(claims) {
            this.updateRegulation('claims', claims)
        },
        addClaim() {
            this.updateClaims(this.claims.concat({
                type: null,
                evidence: null,
            }))
        },
    },
}
